var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProviderCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500018 9.35733C0.490515 8.91069 0.571325 8.46672 0.737602 8.05207C0.903879 7.63742 1.1522 7.26063 1.46766 6.94429C1.78312 6.62796 2.15923 6.3786 2.57342 6.21118C2.98761 6.04376 3.43135 5.96173 3.87802 5.97C4.23066 5.16817 4.80711 4.48507 5.53823 4.00263C6.26935 3.52018 7.12411 3.25886 8.00002 3.25C9.18562 3.27232 10.3177 3.74753 11.1641 4.57812C12.0104 5.4087 12.5068 6.53169 12.5514 7.71667C12.9149 7.64535 13.2898 7.65661 13.6484 7.74962C14.007 7.84263 14.3402 8.01502 14.6232 8.25404C14.9063 8.49307 15.132 8.79263 15.2838 9.1306C15.4355 9.46857 15.5094 9.83631 15.5 10.2067C15.5 12.792 12.8914 12.7513 12.8914 12.7513H3.43469C2.61742 12.637 1.86944 12.2299 1.32969 11.6057C0.789944 10.9815 0.49513 10.1825 0.500018 9.35733V9.35733Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.75L9.5 10.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.75L12.5 10.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderCloud);
export default __webpack_public_path__ + "static/media/provider_cloud.a7d2c093.svg";
export { ForwardRef as ReactComponent };